import React from 'react';

import { SimpleTextToggle } from '~/src/dash/components/toggles/SimpleTextToggle';
import { Col, Cols, spacing, Text, TKey, usePublicaTranslation } from '~/src/dash/publicaUI';
import { IDateRange } from '~/src/dash/utils/dateTimeRanges';

interface IDateGroup {
  label: string;
  value: number;
  tKey: TKey;
}

const dateGroups = [
  { label: 'Hour', value: 0, tKey: 'Hour' },
  { label: 'Day', value: 1, tKey: 'Day' },
  { label: 'Week', value: 2, tKey: 'Week' },
  { label: 'Month', value: 3, tKey: 'Month' },
] as IDateGroup[];

interface IDateGroupSelectorProps {
  activeDateRange: IDateRange;
  activeGrouping: number;
  handleSelectGrouping: (dateGroup: number) => void;
}

export const DateGroupToggles = ({
  activeDateRange,
  activeGrouping,
  handleSelectGrouping,
}: IDateGroupSelectorProps) => {
  const { dateGroupRange } = activeDateRange;
  const [min, max] = dateGroupRange;
  const { t } = usePublicaTranslation();

  return (
    <Cols
      gap={spacing.large}
      style={{
        justifyContent: 'flex-end',
        alignContent: 'center',
      }}
    >
      <Col>
        <Text
          extraSmall
          muted
          italic
          style={{ height: '28px', lineHeight: '28px', textAlign: 'center' }}
          tKey='ViewBy'
        >
          View By
        </Text>
      </Col>
      {dateGroups.map((group) => {
        const isAllowed = group.value >= min && group.value <= max;
        return (
          <Col>
            <SimpleTextToggle
              active={activeGrouping === group.value}
              disabled={!isAllowed}
              onClick={() => handleSelectGrouping(group.value)}
              value={group.tKey ? t(group.tKey) : group.label}
              size='small'
              tooltipText={!isAllowed ? t('TooltipUnavailableDueToSelectedPeriod') : ''}
            />
          </Col>
        );
      })}
    </Cols>
  );
};
